import solid from './icons/solid';
import light from './icons/light';
import regular from './icons/regular';
import cartSolid from './icons/cart/solid';
import cartRegular from './icons/cart/regular';
import cartLight from './icons/cart/light';
import spinnerSolid from './icons/spinner/solid';
import spinnerRegular from './icons/spinner/regular';
import spinnerLight from './icons/spinner/light';

export function getIconsByStyle(style) {
    switch (style){
        case "light":
            return light;
        case "regular":
            return regular;
        case "solid":
        default:
            return solid;
    }
}

function selectStyledIconMap(iconStyle) {
    switch (iconStyle){
        case "light":
            return cartLight;
        case "regular":
            return cartRegular;
        case "solid":
        default:
            return cartSolid;
    }
}

function selectStyledIconMapSpinner(iconStyle) {
    switch (iconStyle){
        case "light":
            return spinnerLight;
        case "regular":
            return spinnerRegular;
        case "solid":
        default:
            return spinnerSolid;
    }
}

export function getCartIcon(iconStyle, cartIconStyle) {
    const map = selectStyledIconMap(iconStyle);
    return map.get(cartIconStyle) || map.get("shopping-cart");
}

export function getSpinnerIcon(iconStyle, spinnerIconStyle) {
    const map = selectStyledIconMapSpinner(iconStyle);
    return map.get(spinnerIconStyle) || map.get("spinner-third");
}

export const availableIconStyles = ["light","regular","solid"];
export const availableCartIconStyles = ["shopping-cart"];
export const availableSpinnerIconStyles = ["spinner-third", "spinner", "fan", "cog", "badge"];